import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../utils/api";

function* updateOldLeaderboard(action) {
  const { payload } = action || {};
  const { name } = payload;
  const action_1 = Object.assign({});
  action_1.handler = "V3_GET_OLD_LEADERBOARD";
  action_1.query = { 
    name: payload.name,
    limit: payload.limit,
    offset: payload.offset
   };
      const response = yield call(api, action_1);
      if (response.status === 200) {
        yield put({ type: "UPDATE_OLD_LEADERBOARD", oldleaderboard: response.data });
      }
    
  }
  
function* getOldLeaderboard() {
  yield takeLatest("GET_OLD_LEADERBOARD", updateOldLeaderboard);
}

//------------------------------------------------------------------------------------------------------

export default [getOldLeaderboard];


// WEBPACK FOOTER //
// ./src/shells/oldLeaderboard/sagas.js